module.exports = __webpack_public_path__ + "img/UTFLIG-4.5df1672f.jpg";